/**
 * 商品画像・カード画像の読み込み中にシマーを表示
 */
(function () {
  const IMAGE_SELECTOR =
    '.product-media-container .product__media img, .card__media .media img, .tata-season-lookbook__media img';
  const MIN_SHIMMER_MS = 320;

  function getHost(img) {
    if (img.closest('.tata-season-lookbook__media')) {
      return img.closest('.tata-season-lookbook__media');
    }
    if (img.closest('.product-media-container')) {
      return img.closest('.product__media');
    }
    if (img.closest('.card__media')) {
      return img.closest('.card__media .media');
    }
    return null;
  }

  function shimmerStartedAt(host) {
    const fromDom = Number(host.dataset.tataShimmerStart);
    if (fromDom) return fromDom;
    const now = Date.now();
    host.dataset.tataShimmerStart = String(now);
    return now;
  }

  function setPending(host) {
    shimmerStartedAt(host);
    host.classList.add('tata-media-shimmer', 'tata-media-shimmer--pending');
    host.classList.remove('tata-media-shimmer--loaded');
  }

  function setLoaded(host) {
    const started = shimmerStartedAt(host);
    const delay = Math.max(0, MIN_SHIMMER_MS - (Date.now() - started));

    window.setTimeout(() => {
      host.classList.remove('tata-media-shimmer--pending');
      host.classList.add('tata-media-shimmer', 'tata-media-shimmer--loaded');
    }, delay);
  }

  function isImageReady(img) {
    return img.complete && img.naturalWidth > 0;
  }

  function setLoadedNow(host) {
    host.classList.remove('tata-media-shimmer--pending');
    host.classList.add('tata-media-shimmer', 'tata-media-shimmer--loaded');
  }

  function bindImage(img) {
    if (!img || img.dataset.tataMediaShimmerBound === 'true') return;

    const host = getHost(img);
    if (!host) return;

    img.dataset.tataMediaShimmerBound = 'true';

    // カードのホバー用 2 枚目は 990px 未満では読み込まない（display: none）ので、待たない
    if (host.classList.contains('media--hover-effect') && img !== host.querySelector('img')) return;

    // 最初から読み込む画像（loading="lazy" でないもの＝商品のメイン画像・一覧の先頭など）は LCP になるので、
    // 隠さずにそのまま表示する。シマーはスクロールして出てくる遅延読み込みの画像だけ
    if (img.getAttribute('loading') !== 'lazy') {
      setLoadedNow(host);
      return;
    }

    // 画像はサーバー側では隠さない。このスクリプトが動いた時点で読み込み済みなら
    // そのまま表示し（LCP を遅らせない）、未読込の画像にだけスケルトンを出す
    if (isImageReady(img)) {
      setLoadedNow(host);
      return;
    }

    setPending(host);

    const syncState = () => {
      if (isImageReady(img)) {
        setLoaded(host);
      } else {
        setPending(host);
      }
    };

    img.addEventListener('load', syncState);
    img.addEventListener('error', syncState);
  }

  function scan(root) {
    root.querySelectorAll(IMAGE_SELECTOR).forEach(bindImage);
  }

  function init() {
    scan(document);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches?.('img') && node.closest('.product-media-container, .card__media, .tata-season-lookbook__media')) {
            bindImage(node);
          }
          scan(node);
        });
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
